import React, { useState, useEffect } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { Button, Tooltip, NativeSelect, Paper } from "@material-ui/core";
import api from "../../../../services/api";
import { useParams } from "react-router-dom";
import "../../TargetReport/TableContent/index.css";
import { useMessageBox } from "../../../../context/MessageBox";
import excelIcon from "../../../../assets/images/excel48.png";
import { toast } from "react-toastify";
import * as S from './formStyle';

function OperationsMiddle({
  setTableData,
  setIsLoading,
  isLoading,
}) {
  const classes = S.useStyles();
  const [dateForm, setDateForm] = useState(new Date());
  const [report, setReport] = useState();
  const screenParams = {
    title: "Relatorio Analistas Ancoras Antecipações", 
    apiTable: "Relatorios/Relatorio010AnalistasAncorasAntecipacoes",
    apiDownloadExcel: "Relatorios/Relatorio010AnalistasAncorasAntecipacoesDownloadExcel",
    dateFormat: "MM/yyyy",
  };

  const { setMessageData } = useMessageBox();

  useEffect(async () => {
    if (dateForm) {
      await getInfoForForm();
    }
  }, [dateForm]);

  const getInfoForForm = async () => {
    const model = {
        mes: new Date(dateForm).getMonth() + 1,
        ano: new Date(dateForm).getFullYear(),
    };
    setReport(model);
    setIsLoading(true);

    try {
      const relatorio = await api.post(screenParams.apiTable, model);

      if (relatorio?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(relatorio?.data?.complemento?.mensagensBox);
      }

      if (relatorio.data.status !== "Sucesso") {
        if (relatorio.data.resposta) {
          if (relatorio.data.resposta.length > 0) {
            relatorio.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
      } else {
        setTableData(relatorio.data.resposta.itens);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const exportTable = async () => {
    if (!report) {
      return;
    }
    setIsLoading(true);

    try {
      const relatorio = await api.post(screenParams.apiDownloadExcel, report);

      if (relatorio?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(relatorio?.data?.complemento?.mensagensBox);
      }

      if (relatorio.data.status !== "Sucesso") {
        if (relatorio.data.resposta) {
          if (relatorio.data.resposta.length > 0) {
            relatorio.data.resposta.forEach((element) => {
              toast.error(element.message);
            });
          }
        }
        return;
      }

      const a = document.createElement("a");
      a.href =
        "data:" +
        relatorio.data.resposta.contentType +
        ";base64," +
        relatorio.data.resposta.fileContents;
      a.download = relatorio.data.resposta.fileDownloadName;
      a.click();
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div style={{ height: "100%" }}>
        <div
          className='new-body-schedule'
          style={{
            justifyContent: "space-between",
            display: "flex",
            marginTop: "20px",
            alignItems: "center", 
          }}>
          <p></p>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className='schedule-input'
              style={{ display: 'flex', marginTop: '8px', alignItems: 'center',  flexDirection: 'column' }}
            >
              <span className={classes.label}>Mês/Ano: </span>
              <div style={{ display: "flex", alignItems: 'center' }}>
                <Button
                  value={dateForm}
                  style={{
                    minWidth: "20px",
                    width: "20px",
                    height: "23px",
                    paddingLeft: "20px",
                  }}
                  onClick={() => {
                    const newDate = new Date(dateForm);
                    setDateForm(newDate.setMonth(newDate.getMonth() - 1));
                  }}>
                  🢀
                </Button>

                <div
                  style={{
                    padding: "0px 5px",
                    maxWidth: "150px",
                    height: "23px",
                  }}>
                  <DatePicker
                    selected={dateForm}
                    onChange={(date) => {
                      setDateForm(date);
                    }}
                    dateFormat={screenParams.dateFormat}
                    locale='ptBR'
                  />
                </div>

                <Button
                  style={{ minWidth: "20px", width: "20px", height: "23px" }}
                  onClick={() => {
                      const newDate = new Date(dateForm);
                      setDateForm(newDate.setMonth(newDate.getMonth() + 1));
                  }}>
                  🢂
                </Button>
              </div>
            </div>
          </div>
          <div>
            <img
              src={excelIcon}
              onClick={() => {
                exportTable();
              }}
              style={{ cursor: "pointer", marginRight: "8px" }}></img>
          </div>
        </div>
      </div>
    </>
  );
}

export default OperationsMiddle;
